import {
	Paper,
	styled,
	Table,
	TableBody,
	TableContainer,
	TablePagination,
	Typography,
} from "@mui/material";
import { types } from "api";
import { RegisteredUserList } from "api/types";
import { getComparator, Order, stableSort } from "helpers/tableComparator";
import React, { useState } from "react";
import ReactLoading from "react-loading";
import { RegisteredUserTableHead } from "./RegisteredUserTableHead";
import { RegisteredUserTableRow } from "./RegisteredUserTableRow";

const PREFIX = "ResgisteredUserTable";

const classes = {
	root: `${PREFIX}-root`,
	paper: `${PREFIX}-paper`,
	table: `${PREFIX}-table`,
	hide: `${PREFIX}-hide`,
	button: `${PREFIX}-button`,
	errBtn: `${PREFIX}-errBtn`,
	load: `${PREFIX}-load`,
};

const Root = styled("div")(({ theme }) => ({
	[`&.${classes.root}`]: {
		width: "100%",
	},
	[`& .${classes.paper}`]: {
		width: "100%",
		marginBottom: theme.spacing(2),
	},

	[`& .${classes.table}`]: {
		minWidth: 750,
	},

	[`& .${classes.hide}`]: {
		display: "none",
	},

	[`& .${classes.button}`]: {
		float: "left",
		margin: "10",
	},

	[`& .${classes.errBtn}`]: {
		color: theme.palette.error.main,
	},

	[`& .${classes.load}`]: {
		marginLeft: theme.spacing(20),
	},
}));

export interface ResgisteredUserTableProps {
	/**
	 * Additional toolbar buttons.
	 */
	children?: JSX.Element | JSX.Element[];
	users: RegisteredUserList;
	title?: string;
	isloading: boolean;
}

export const RegisteredUserTable = ({
	users,
	title = "Registered User List",
	isloading,
}: ResgisteredUserTableProps): JSX.Element => {
	const [order, setOrder] = useState<Order>("asc");
	const [orderBy, setOrderBy] =
		useState<keyof types.RegisteredUser>("firstName");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const handleRequestSort = (
		event: React.MouseEvent<unknown>,
		property: keyof types.RegisteredUser,
	): void => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};

	const handleChangePage = (event: unknown, newPage: number): void => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event: React.ChangeEvent<HTMLInputElement>,
	): void => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	return (
		<Root className={classes.root}>
			<Paper className={classes.paper}>
				<div style={{ padding: 20 }}>
					<Typography variant="h4" data-testid="hello">
						Register Users
					</Typography>
					<div style={{ paddingTop: 8 }}>
						{" "}
						Total register numbers:{users.length}{" "}
					</div>
				</div>

				<TableContainer>
					<Table
						className={classes.table}
						aria-labelledby={title}
						aria-label="enhanced table"
					>
						<RegisteredUserTableHead
							order={order}
							orderBy={orderBy}
							onRequestSort={handleRequestSort}
						/>
						<TableBody>
							{isloading ? (
								<ReactLoading
									className={classes.load}
									type={"bars"}
									color={"#09203F"}
								/>
							) : (
								stableSort(users, getComparator(order, orderBy))
									.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
									.map((row) => (
										<RegisteredUserTableRow row={row} key={row.userId} />
									))
							)}
						</TableBody>
					</Table>
				</TableContainer>

				<TablePagination
					rowsPerPageOptions={[10, 20, 30]}
					component="div"
					count={users.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Paper>
		</Root>
	);
};
